import InteractiveAnnotation from "./interactiveAnnotation";
import { measureText, setFontStyle } from "../canvasUtils";
import SegmentChainArea from "./segmentChainArea";
import MeasurementText from "./measurementText";

export default class FreeHandArea extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);
    this.chain = new SegmentChainArea(position, options);
    this.measurementText = new MeasurementText();
    this.textActive = false;
  }

  get text() {
    let scaled = this.chain.area * this.scale * this.scale;
    return scaled.toFixed(2) + " mm²";
  }

  get textPosition() {
    let min = this.chain.min;
    let max = this.chain.max;
    let x = (min.x + max.x - this.textWidth) / 2;
    let y = max.y;
    return {x, y};
  }

  get textWidth(){
    return measureText(this.text, this.font);
  }

  draw(ctx) {
    this.chain.draw(ctx);
    if (this.chain.active && !this.chain.drawingInitialLine) this.chain.drawBoundingBox(ctx);
    if (this.chain.closed) {
      this.drawText(ctx);
      if (this.textActive) this.measurementText.drawTextInteractionBoxe(ctx)
    }
  }

  drawText(ctx){
    setFontStyle(ctx, this);
    this.measurementText.updateAndDraw(this.textWidth, this.textSize, ctx, this.text, this.textPosition.x, this.textPosition.y);
  }

  isInBounds(x, y) {
    return this.chain.isOnLines(x, y) || this.isInBoundsText(x, y);
  }

  isInBoundsText(x, y){
    return this.measurementText.isInBound(x, y)
  }

  mousedown(x, y) {
    if(this.measurementText.isInBound(x, y)) this.textActive = true;
    else this.chain.mousedown(x, y);
    
    this.signalReady();
  }

  mousemove(x, y) {
    if(this.textActive) this.measurementText.updateLocation(x, y);
    else this.chain.mousemove(x, y);
    
    this.signalReady();
  }

  mouseup() {
    this.chain.mouseup();
    this.signalReady();
  }

  deactivate() {
    this.chain.deactivate();
    this.clearActiveStates();
    this.signalReady();
  }
  clearActiveStates(){
    this.textActive = false;
  }
  
  setLineWidth(width) {
    this.chain.setLineWidth(width);
    this.signalReady();
  }

  updateColor(color) 
  {
    this.chain.color = color;
    this.color = color;
  }
}